import { NodeEnv } from "../trade/campaigns/getCampaigns";

export const getRewardsSafeModuleAddress = (nodeEnv: NodeEnv): string => {
  if (nodeEnv === "production") {
    return "0x153B3A08Da2FBC4b37Bb7e958F8e74eD68e8cede";
  }
  if (nodeEnv === "staging") {
    return "0xECe4E60221b19c30Ea8C091460Aa9879F0Acede0";
  }
  // Default to development address
  return "0x763c41eE1Bb71d9168028d1914F33Edfd4D5F874";
};

export const CEDE_REWARDS_SAFE_ABI = [
  {
    type: "constructor",
    inputs: [
      { name: "_governance", type: "address", internalType: "address" },
      {
        name: "_cedeSafeManager",
        type: "address",
        internalType: "address",
      },
      {
        name: "_epochManager",
        type: "address",
        internalType: "address",
      },
      {
        name: "_pauseManagers",
        type: "address[]",
        internalType: "address[]",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "CEDE_SAFE_MANAGER_ROLE",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "DEFAULT_ADMIN_ROLE",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "EPOCH_MANAGER_ROLE",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "PAUSE_MANAGER_ROLE",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "cedeSafeLength",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "claimReward",
    inputs: [
      {
        name: "_claim",
        type: "tuple",
        internalType: "struct ICedeRewardsSafeModule.Claim",
        components: [
          { name: "user", type: "address", internalType: "address" },
          {
            name: "cedeSafe",
            type: "address",
            internalType: "address",
          },
          { name: "epochId", type: "uint256", internalType: "uint256" },
          { name: "amount", type: "uint256", internalType: "uint256" },
          {
            name: "proof",
            type: "bytes32[]",
            internalType: "bytes32[]",
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "claimRewards",
    inputs: [
      {
        name: "_claims",
        type: "tuple[]",
        internalType: "struct ICedeRewardsSafeModule.Claim[]",
        components: [
          { name: "user", type: "address", internalType: "address" },
          {
            name: "cedeSafe",
            type: "address",
            internalType: "address",
          },
          { name: "epochId", type: "uint256", internalType: "uint256" },
          { name: "amount", type: "uint256", internalType: "uint256" },
          {
            name: "proof",
            type: "bytes32[]",
            internalType: "bytes32[]",
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "claimedEpochs",
    inputs: [
      { name: "", type: "address", internalType: "address" },
      { name: "", type: "uint256", internalType: "uint256" },
      { name: "", type: "address", internalType: "address" },
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "cooldownDuration",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "createEpoch",
    inputs: [
      { name: "_cedeSafe", type: "address", internalType: "address" },
      { name: "_epochId", type: "uint256", internalType: "uint256" },
      {
        name: "_rewardToken",
        type: "address",
        internalType: "address",
      },
      { name: "_merkleRoot", type: "bytes32", internalType: "bytes32" },
      { name: "_ipfsCID", type: "bytes", internalType: "bytes" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "createNewCedeSafe",
    inputs: [
      { name: "_owners", type: "address[]", internalType: "address[]" },
      { name: "_threshold", type: "uint256", internalType: "uint256" },
      { name: "_salt", type: "uint256", internalType: "uint256" },
    ],
    outputs: [
      {
        name: "_cedeSafeProxy",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "delegateActivateModule",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "epochs",
    inputs: [
      { name: "", type: "address", internalType: "address" },
      { name: "", type: "uint256", internalType: "uint256" },
    ],
    outputs: [
      { name: "rewardToken", type: "address", internalType: "address" },
      { name: "merkleRoot", type: "bytes32", internalType: "bytes32" },
      { name: "cooldownEnd", type: "uint256", internalType: "uint256" },
      { name: "isTerminated", type: "bool", internalType: "bool" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getRoleAdmin",
    inputs: [{ name: "role", type: "bytes32", internalType: "bytes32" }],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "grantRole",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      { name: "account", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "hasRole",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      { name: "account", type: "address", internalType: "address" },
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "isCedeSafe",
    inputs: [{ name: "", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "paused",
    inputs: [],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "renounceRole",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      {
        name: "callerConfirmation",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "revokeRole",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      { name: "account", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "supportsInterface",
    inputs: [{ name: "interfaceId", type: "bytes4", internalType: "bytes4" }],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "terminateEpoch",
    inputs: [
      { name: "_cedeSafe", type: "address", internalType: "address" },
      { name: "_epochId", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "unpause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "updateCooldownDuration",
    inputs: [
      {
        name: "_newCooldownDuration",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "CedeSafeCreated",
    inputs: [
      {
        name: "cedeSafeId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "cedeSafeAddress",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "CooldownUpdate",
    inputs: [
      {
        name: "newCooldownDuration",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EpochCreated",
    inputs: [
      {
        name: "cedeSafe",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "epochId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "rewardToken",
        type: "address",
        indexed: false,
        internalType: "address",
      },
      {
        name: "merkleRoot",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32",
      },
      {
        name: "cooldownEnd",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "ipfsCID",
        type: "bytes",
        indexed: false,
        internalType: "bytes",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EpochTerminated",
    inputs: [
      {
        name: "cedeSafe",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "epochId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RewardsClaimed",
    inputs: [
      {
        name: "cedeSafe",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "epochId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "user",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoleAdminChanged",
    inputs: [
      {
        name: "role",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "previousAdminRole",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "newAdminRole",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoleGranted",
    inputs: [
      {
        name: "role",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "sender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoleRevoked",
    inputs: [
      {
        name: "role",
        type: "bytes32",
        indexed: true,
        internalType: "bytes32",
      },
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "sender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Unpaused",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  { type: "error", name: "ALREADY_CLAIMED", inputs: [] },
  { type: "error", name: "AccessControlBadConfirmation", inputs: [] },
  {
    type: "error",
    name: "AccessControlUnauthorizedAccount",
    inputs: [
      { name: "account", type: "address", internalType: "address" },
      { name: "neededRole", type: "bytes32", internalType: "bytes32" },
    ],
  },
  { type: "error", name: "CANT_MODIFY", inputs: [] },
  { type: "error", name: "COOLDOWN_IN_PROGRESS", inputs: [] },
  { type: "error", name: "EPOCH_TERMINATED", inputs: [] },
  { type: "error", name: "EnforcedPause", inputs: [] },
  { type: "error", name: "ExpectedPause", inputs: [] },
  { type: "error", name: "INVALID_PROOF", inputs: [] },
  { type: "error", name: "NOT_ENOUGH_FUNDS", inputs: [] },
  { type: "error", name: "ONLY_GOVERNANCE", inputs: [] },
  { type: "error", name: "ONLY_REWARD_MANAGER", inputs: [] },
  { type: "error", name: "REWARD_TRANSFER_ERROR", inputs: [] },
  { type: "error", name: "UNKNOWN_CEDE_SAFE", inputs: [] },
  { type: "error", name: "UNKNOWN_EPOCH", inputs: [] },
] as const;

/** CedeRewardsSafeModuleV3 additions (instant payouts), on top of the V1 ABI. */
export const CEDE_REWARDS_SAFE_V3_ABI = [
  ...CEDE_REWARDS_SAFE_ABI,
  {
    type: "function",
    name: "instantPayout",
    inputs: [
      {
        name: "_cedeSafe",
        type: "address",
        internalType: "address",
      },
      {
        name: "_epochId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_rewardToken",
        type: "address",
        internalType: "address",
      },
      {
        name: "_user",
        type: "address",
        internalType: "address",
      },
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "instantPayoutAvailableBudget",
    inputs: [
      {
        name: "_rewardToken",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "_available",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "instantPayoutConfigs",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "maxAmount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "dailyBudget",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "budgetAvailable",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "budgetUpdatedAt",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "version",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "error",
    name: "DEFI_ADDRESS_BANNED",
    inputs: [],
  },
  {
    type: "error",
    name: "EPOCH_ALREADY_EXISTS",
    inputs: [],
  },
  {
    type: "error",
    name: "INSTANT_PAYOUT_ABOVE_MAX",
    inputs: [],
  },
  {
    type: "error",
    name: "INSTANT_PAYOUT_BUDGET_EXCEEDED",
    inputs: [],
  },
  {
    type: "error",
    name: "INVALID_AMOUNT",
    inputs: [],
  },
] as const;

export const ERC20_ABI = [
  {
    constant: true,
    inputs: [{ name: "_owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "balance", type: "uint256" }],
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    type: "function",
  },
] as const;
